import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";

import { useRootAppStore } from "@hooks";
import LoaderSpinner from "@components-shared/LoaderSpinner";

import {
	PopupBody,
	PopupHeader,
	PopupInfo,
} from "@features/chat/mobile/ChatBetSlipSharedPopup";

import { useFixBody } from "@state/hooks/shared";

import { SharedBetSlipPopupFooter } from "./SharedBetSlipPopupFooter";

export default observer(function SharedBetSlipPopup() {
	const location = useLocation();

	const { quickPlayStore } = useRootAppStore();

	const { sharedBetSlipStore } = quickPlayStore;
	const betSlipData = sharedBetSlipStore.sharedBetSlipPopup;

	useFixBody(true, sharedBetSlipStore.isPopupDisplayed);

	if (
		!location.pathname.includes("home") &&
		!location.pathname.includes("shared-bet-slips")
	) {
		sharedBetSlipStore.deactivatePopup();
	}

	if (
		sharedBetSlipStore.betSlipShareDetails.isFetchingData &&
		!sharedBetSlipStore.blockMainLoader
	) {
		return <LoaderSpinner isLoading />;
	}

	if (!betSlipData) {
		return null;
	}

	return (
		<div className="popup popup--sbs">
			<div className="popup__card popup--sbs__card">
				<PopupHeader onClose={sharedBetSlipStore.deactivatePopup} />
				<div className="popup__body u-padd--top--reset">
					<PopupInfo bet={betSlipData} />
					<div className="popup__ticket bet">
						<PopupBody bet={betSlipData} />
					</div>
				</div>
				<SharedBetSlipPopupFooter bet={betSlipData} />
			</div>
		</div>
	);
});
